import React from "react";
import PropTypes from "prop-types";

import "./CheckBox.scss";

export default class CheckBox extends React.Component {
  state = {};
  render() {
    return (
      <div className="checkBox">
        <label htmlFor="test">{this.props.label}</label>
        <input
          type="checkbox"
          name="test"
          id="test"
          checked={this.props.checked}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

CheckBox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};
